import React from 'react';
import Slider, { Settings } from 'react-slick';
import styles from './styles.module.scss';

import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';
import Projectimg1 from '../../../assets/newhomepageimg/projectimg1.webp';
import Projectimg2 from '../../../assets/newhomepageimg/projectimg2.webp';

import H3 from '../../../components/typography/h3';
import HeroSlider from './slider';

interface Brand {
  title: string;
  description: string;
  image: string;
}

const brands: Brand[] = [
  {
    title: 'Website Design',
    description: 'Scentabook',
    image: Projectimg1,
  },
  {
    title: 'Genuine IT Systems',
    description: 'Website Design',
    image:Projectimg2,
  },
  {
    title: 'Website Design',
    description: 'Scentabook',
    image: Projectimg1,
  },
  {
    title: 'Genuine IT Systems',
    description: 'Website Design',
    image:Projectimg2,
  },
   {
    title: 'Website Design',
    description: 'Scentabook',
    image: Projectimg1,
  },
  {
    title: 'Genuine IT Systems',
    description: 'Website Design',
    image:Projectimg2,
  },
];

interface ArrowProps {
  onClick?: () => void;
}

const PrevArrow: React.FC<ArrowProps> = ({ onClick }) => (
  <div className={`${styles.arrow} ${styles.prev}`} onClick={onClick}>
<svg width="10" height="17" viewBox="0 0 10 17" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M0.621485 8.10248L8.80273 1.04701C9.10781 0.784903 9.55469 1.02123 9.55469 1.44447V15.5554C9.55469 15.9787 9.10781 16.215 8.80273 15.9529L0.621485 8.8974C0.387305 8.69545 0.387305 8.30443 0.621485 8.10248Z" fill="#FF2E84"/>
</svg>

  </div>
);

const NextArrow: React.FC<ArrowProps> = ({ onClick }) => (
  <div className={`${styles.arrow1} ${styles.next}`} onClick={onClick}>
   <svg width="22" height="23" viewBox="0 0 22 23" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M15.3785 11.1024L7.19727 4.04689C6.89219 3.78478 6.44531 4.02111 6.44531 4.44435V18.5553C6.44531 18.9785 6.89219 19.2149 7.19727 18.9528L15.3785 11.8973C15.6127 11.6953 15.6127 11.3043 15.3785 11.1024Z" fill="white"/>
</svg>

  </div>
);
const BrandSlider: React.FC = () => {
  const settings: Settings = {
    infinite: true,
    speed: 500,
    slidesToShow: 2,
    slidesToScroll: 1,
    nextArrow: <NextArrow />,
    prevArrow: <PrevArrow />,
    responsive: [
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 1,
        },
      },
    ],
  };

  return (
    <div className={styles.wrapper}>
        <H3>
      <h2 className={styles.heading}>
{/* A Collection of Projects That Reflect
Our Expertise and Innovation */}
Explore our digital brands that deliver
practical solutions for your business.
      </h2>
      </H3>
      <HeroSlider/>
      {/* <div className={styles.sliderWrapper}>
        <Slider {...settings} className={styles.slider}>
          {brands.map((brand, index) => (
            <div key={index} className={styles.card}>
              <img src={brand.image} alt={brand.title} className={styles.image} />
              <h3 className={styles.title}>{brand.title}</h3>
              <p className={styles.desc}>{brand.description}</p>
            </div>
          ))}
        </Slider>
      </div> */}
    </div>
  );
};

export default BrandSlider;
